import { render, staticRenderFns } from "./XdeskView.vue?vue&type=template&id=37be1f6e&"
import script from "./XdeskView.vue?vue&type=script&lang=js&"
export * from "./XdeskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports